import { z } from "zod";

export const NoteSchema = z.object({
  clientId: z.string().cuid(),
  content: z.record(z.unknown()),
});

export type NoteDto = z.infer<typeof NoteSchema>;
